/* WS a11y runtime fixes (24 Oct 2026).
   Some markup is created in the browser by apps and sliders (Boost grid,
   Slick, Shogun video, review widgets), after the theme's server-side fixes
   have run. This file patches only accessibility attributes on that markup;
   it never changes text, layout or behaviour. Safe to remove: delete the
   script tag in layout/theme.liquid. */
(function () {
  'use strict';
  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex]';
  var IMG_EXT = /\.(jpe?g|png|gif|webp|svg|avif)$/i;

  /* A name for an image link built from where it goes. Same-site page: its
     last meaningful path part. Image file / image server: "View larger
     image". Other site: its domain. "#", javascript:, mailto: and tel:
     links get no made-up name (returns ''). */
  var SKIP_SEG = /^(blog|blogs|weddings|pages|products|collections|news|files|uploads|sized|index|default|home|pr|s|en|en-us|www)$/;
  function words(href) {
    href = (href || '').trim();
    if (!href || href.charAt(0) === '#' || /^(javascript|mailto|tel):/i.test(href)) return '';
    try {
      var u = new URL(href, location.href);
      if (!/^https?:$/.test(u.protocol)) return '';
      var host = u.hostname.toLowerCase().replace(/^www\./, '');
      var segs = u.pathname.split('/').filter(Boolean);
      var last = segs.length ? segs[segs.length - 1] : '';
      if (IMG_EXT.test(last) || /(^|\.)(images|cdn)\.|amazonaws\.com$/.test(host) || /\/(uploads|files)\//i.test(u.pathname)) return 'View larger image';
      if (host !== 'weddingshoppeinc.com' && host !== location.hostname.toLowerCase().replace(/^www\./, '')) return host;
      var any = '', seg = '';
      for (var i = segs.length - 1; i >= 0 && !seg; i--) {
        var b = segs[i].split('.')[0];
        try { b = decodeURIComponent(b); } catch (e) {}
        if (!/[a-z]/i.test(b)) continue;
        if (!any) any = b;
        if (!SKIP_SEG.test(b.toLowerCase())) seg = b;
      }
      if (!seg) {
        if (/^(blog|blogs|weddings)$/i.test(any)) return 'Wedding Shoppe blog';
        if (!any) return 'Wedding Shoppe home page';
        seg = any;
      }
      seg = seg.replace(/[-_+]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
      return seg ? seg.charAt(0).toUpperCase() + seg.slice(1) : '';
    } catch (e) { return ''; }
  }

  function textOf(el, skip) {
    var t = '';
    el.childNodes.forEach(function (n) {
      if (n === skip) return;
      if (n.nodeType === 3) t += n.nodeValue;
      else if (n.nodeType === 1) {
        if (n.tagName === 'IMG' && n.getAttribute('alt')) t += n.getAttribute('alt');
        else if (n.getAttribute && n.getAttribute('aria-hidden') !== 'true') t += textOf(n, skip);
      }
    });
    return t.replace(/\s+/g, ' ').trim();
  }

  function pageName() {
    var h = document.querySelector('h1');
    return h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* Missing or blank alt. An image that is the only thing in a link or
     button names that control; any other image without alt is decorative. */
  function fixImg(img) {
    var alt = img.getAttribute('alt');
    if (alt !== null && alt.trim() !== '') return;
    var link = img.closest('a[href], button');
    if (link && !link.getAttribute('aria-label') && !link.getAttribute('aria-labelledby') && !textOf(link, img)) {
      var href = link.getAttribute('href') || '';
      var name = link.getAttribute('title') || img.getAttribute('title') ||
        (IMG_EXT.test(href.split('?')[0]) && pageName() ? pageName() : '') ||
        (link.tagName === 'A' ? words(href) : '');
      if (name) { img.setAttribute('alt', name); return; }
    }
    if (alt === null || alt !== '') img.setAttribute('alt', '');
  }

  function fixFrame(f) {
    if (f.hasAttribute('title') || f.hasAttribute('aria-label')) return;
    var s = (f.getAttribute('src') || f.getAttribute('data-src') || '').toLowerCase();
    f.setAttribute('title', /youtube|vimeo|wistia/.test(s) ? 'Embedded video' : 'Embedded content');
  }

  /* Slick and Swiper hide off-screen slides with aria-hidden="true" but can
     leave their links focusable; take those out of the tab order while
     hidden. On the way back we never restore a -1 (Slick may have set it
     itself just before we saw the slide): the link simply returns to the
     normal tab order. */
  function syncHidden(el) {
    var hidden = el.getAttribute('aria-hidden') === 'true';
    el.querySelectorAll(FOCUSABLE).forEach(function (c) {
      if (hidden) {
        if (c.getAttribute('tabindex') !== '-1' && !c.hasAttribute('data-ws-tabindex')) {
          c.setAttribute('data-ws-tabindex', c.hasAttribute('tabindex') ? c.getAttribute('tabindex') : 'none');
          c.setAttribute('tabindex', '-1');
        }
      } else {
        restore(c);
        if (c.getAttribute('tabindex') === '-1' && c.closest('.slick-slide') && /^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(c.tagName)) c.removeAttribute('tabindex');
      }
    });
  }
  function restore(c) {
    if (!c.hasAttribute('data-ws-tabindex')) return;
    var o = c.getAttribute('data-ws-tabindex');
    c.removeAttribute('data-ws-tabindex');
    if (o === 'none' || o === '-1') c.removeAttribute('tabindex'); else c.setAttribute('tabindex', o);
  }

  function fixScroll(el, always) {
    if (el.hasAttribute('tabindex')) return;
    var kids = el.querySelectorAll(FOCUSABLE);
    for (var k = 0; k < kids.length; k++) if (kids[k].tabIndex >= 0) return;
    if (always || el.scrollHeight > el.clientHeight + 2 || el.scrollWidth > el.clientWidth + 2) {
      el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('role') && !/^(UL|OL)$/.test(el.tagName)) el.setAttribute('role', 'region');
      if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', 'Scrollable content');
    }
  }

  /* Klaviyo sign-up forms are styled in Klaviyo; the WS pink button
     (#FB758D, white text 2.6:1) is darkened to #B8285A (6.0:1). */
  function fixKlaviyo(btn) {
    if (btn.hasAttribute('data-ws-kl')) return;
    var cs = getComputedStyle(btn);
    if (cs.backgroundColor.replace(/\s/g, '') === 'rgb(251,117,141)' && /^rgb\(255,\s*255,\s*255\)$/.test(cs.color)) {
      btn.style.setProperty('background-color', '#B8285A', 'important');
      btn.setAttribute('data-ws-kl', '1');
    }
  }

  /* Globo product-options dropdowns (size, delivery date) are built from
     divs and hidden radio buttons, so they could not be used with a
     keyboard or screen reader. Give them button/listbox/option roles and
     arrow-key / Enter / Escape handling. Selection still goes through the
     app's own label click, so the app and cart behave exactly as before. */
  var gpoN = 0;
  function enhanceGpo(dd) {
    if (dd.hasAttribute('data-ws-gpo')) return;
    var btn = dd.querySelector('.dropdown-button');
    var list = dd.querySelector('.dropdown-list');
    if (!btn || !list) return;
    dd.setAttribute('data-ws-gpo', '1');
    var n = ++gpoN;
    var wrap = dd.closest('[data-element-id]') || dd.parentElement;
    var lab = wrap ? wrap.querySelector('.label-content') : null;
    if (lab && !lab.id) lab.id = 'ws-gpo-label-' + n;
    var val = btn.querySelector('.dropdown-button__value');
    if (val && !val.id) val.id = 'ws-gpo-value-' + n;
    btn.setAttribute('role', 'button');
    btn.setAttribute('tabindex', '0');
    btn.setAttribute('aria-haspopup', 'listbox');
    if (lab || val) btn.setAttribute('aria-labelledby', [lab && lab.id, val && val.id].filter(Boolean).join(' '));
    list.setAttribute('role', 'listbox');
    if (lab) list.setAttribute('aria-labelledby', lab.id);
    function items() { return [].slice.call(list.querySelectorAll('.dropdown-item')); }
    function isOpen() { return dd.classList.contains('expanded'); }
    function sync() {
      btn.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
      var all = items(), sel = -1;
      all.forEach(function (it, i) {
        var r = it.querySelector('input');
        it.setAttribute('role', 'option');
        it.setAttribute('aria-selected', r && r.checked ? 'true' : 'false');
        if (r && r.checked) sel = i;
        if (r && r.disabled) it.setAttribute('aria-disabled', 'true'); else it.removeAttribute('aria-disabled');
      });
      /* one option in the tab order (roving tabindex): the chosen one, else the first */
      all.forEach(function (it, i) { it.setAttribute('tabindex', i === (sel < 0 ? 0 : sel) ? '0' : '-1'); });
    }
    function focusItem(i) { var all = items(); if (!all.length) return; i = Math.max(0, Math.min(all.length - 1, i)); all[i].focus(); }
    function openList() {
      if (!isOpen()) btn.click();
      sync();
      var all = items(), sel = all.findIndex(function (it) { var r = it.querySelector('input'); return r && r.checked; });
      var tries = 0;
      (function go() {
        focusItem(sel < 0 ? 0 : sel);
        if (!list.contains(document.activeElement) && ++tries < 10) setTimeout(go, 50);
      })();
    }
    function closeList(refocus) { if (isOpen()) btn.click(); sync(); if (refocus) btn.focus(); }
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openList(); }
      else if (e.key === 'Escape' && isOpen()) { e.preventDefault(); closeList(true); }
    });
    list.addEventListener('keydown', function (e) {
      var all = items(), i = all.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); focusItem(i + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); focusItem(i - 1); }
      else if (e.key === 'Home') { e.preventDefault(); focusItem(0); }
      else if (e.key === 'End') { e.preventDefault(); focusItem(all.length - 1); }
      else if ((e.key === 'Enter' || e.key === ' ') && i >= 0) {
        e.preventDefault();
        var l = all[i].querySelector('label');
        if (l) l.click(); else all[i].click();
        setTimeout(function () { closeList(true); }, 30);
      } else if (e.key === 'Escape' || e.key === 'Tab') { if (e.key === 'Escape') e.preventDefault(); closeList(e.key === 'Escape'); }
    });
    list.addEventListener('change', sync);
    new MutationObserver(sync).observe(dd, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  /* Safety net for Shogun buttons added after 24 Oct 2026 (ws-a11y-shogun.css
     only knows the buttons that existed then): light pink / light blue fill
     with white text -> the darker shade. */
  var SHG_PINK = /^rgb\((24[0-9]|25[0-5]), (1[0-4][0-9]), (1[3-5][0-9])\)$/;
  var SHG_BLUE = /^rgb\((10[0-4]), (15[0-5]), (19[5-9]|20[0-4])\)$/;
  function fixShogunBtn(el) {
    if (el.hasAttribute('data-ws-shg')) return;
    el.setAttribute('data-ws-shg', '0');
    var cs = getComputedStyle(el);
    var bg = cs.backgroundColor;
    var LIGHT = /^rgb\(2[4-5][0-9],2[4-5][0-9],2[4-5][0-9]\)$/;
    var light = [el].concat([].slice.call(el.querySelectorAll('*'))).some(function (n) {
      return n.textContent.trim() && LIGHT.test(getComputedStyle(n).color.replace(/\s/g, ''));
    });
    if (!light) return;
    if (SHG_PINK.test(bg)) el.style.setProperty('background-color', '#B8285A', 'important');
    else if (SHG_BLUE.test(bg)) el.style.setProperty('background-color', '#2E6A9E', 'important');
    else return;
    el.setAttribute('data-ws-shg', '1');
  }

  function run(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll('img:not([alt]), img[alt=" "], img[alt="  "], a[href] img[alt=""]').forEach(fixImg);
    root.querySelectorAll('iframe:not([title])').forEach(fixFrame);
    root.querySelectorAll('.slick-slide[aria-hidden], .swiper-slide[aria-hidden]').forEach(syncHidden);
    /* anything we took out of the tab order that is no longer hidden (e.g. slider destroyed) */
    root.querySelectorAll('[data-ws-tabindex]').forEach(function (c) { if (!c.closest('[aria-hidden="true"]')) restore(c); });
    root.querySelectorAll('[class*="__track"]').forEach(function (el) {
      var o = getComputedStyle(el);
      if (/(auto|scroll)/.test(o.overflowX + o.overflowY)) fixScroll(el);
    });
    root.querySelectorAll('.klaviyo-form-button, .needsclick button[type="button"]').forEach(fixKlaviyo);
    root.querySelectorAll('.shg-btn').forEach(fixShogunBtn);
    /* links that still have no name (image set as a CSS background, icon-only) */
    root.querySelectorAll('a[href]:not([aria-label]):not([aria-labelledby]):not([data-ws-ln])').forEach(function (a) {
      if (a.textContent.trim() || a.querySelector('img[alt]:not([alt=""]), svg title, [aria-label], [aria-labelledby]')) return;
      if (!a.children.length && !a.getClientRects().length) return; /* empty and not rendered */
      if (a.getAttribute('aria-hidden') === 'true' || a.closest('[aria-hidden="true"]') || a.tabIndex < 0) return;
      a.setAttribute('data-ws-ln', '1');
      var href = a.getAttribute('href') || '';
      var nm = (a.getAttribute('title') || '').trim() || words(href);
      if (nm) a.setAttribute('aria-label', nm);
    });
    root.querySelectorAll('.gpo-dropdown').forEach(enhanceGpo);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; run(document); });
  }

  function start() {
    run(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var m = ms[i];
        if (m.type === 'childList' && m.addedNodes.length) { schedule(); return; }
        if (m.type === 'attributes') {
          var t = m.target;
          if (m.attributeName === 'aria-hidden' && t.classList && (t.classList.contains('slick-slide') || t.classList.contains('swiper-slide'))) syncHidden(t);
          else if (m.attributeName === 'alt' || m.attributeName === 'title') schedule();
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'alt', 'title'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
